<div class="order-template-header">
  <h1>{{'myaccount.orderTemplate.title'|cxTranslate}}</h1>
  <p>{{'myaccount.orderTemplate.headertext'|cxTranslate}}</p>
</div>
